import { useEffect } from 'react';
import { CartQuantityItem } from '@client/cart/redux/cartQuantity/redux';
import emitter, { EVENT } from '@client/common/utils/eventEmitter';
import { useCartQuantityActions } from './useCartQuantityActions';
import { useCartQuantityItems } from './useCartQuantityItems';

interface CartQuantityHook {
  items: Record<string, CartQuantityItem>;
  setItemQuantity: (sku: string, quantity: number, attemptedQuantity: number) => void;
  incrementItemQuantity: (sku: string, amount?: number) => void;
  clearItems: () => void;
}

export const useCartQuantity = (): CartQuantityHook => {
  const items = useCartQuantityItems();
  const {
    setCartItemQuantity: setItemQuantity,
    incrementCartItemQuantity: incrementItemQuantity,
    clearCartItems: clearItems,
  } = useCartQuantityActions();

  useEffect(() => {
    emitter.on(EVENT.addToCartFulfilled, (data) => {
      const { sku } = data;

      setItemQuantity(sku, 1, 1);

      emitter.off(EVENT.addToCartFulfilled);
    });
  }, []);

  return {
    items,
    setItemQuantity,
    incrementItemQuantity,
    clearItems,
  };
};
